import "./accounts-relation.scss";
export class AccountsRelationCtrl {
    constructor($mdDialog, DSNDialogService, locals) {
        this.locals = locals;
        this.DSNDialogService = DSNDialogService;
        this.$mdDialog = $mdDialog;

        this.listen = [
            'Informações de Receitas e limite de faturamento do tópico "Descritivo de Receitas". ',
            'Folha de Salários, caso tenha fator r, será importado as informações de "Folha de Salários Anteriores" tanto o total acumulado quanto o resultado do período. ',
            "Sublimite de Faturamento descritos na Informações da Declaração por Estabelecimento. ",
            "Valores de Impostos, geral pela empresa, geral por atividades, e segregado por impostos; descritos em Valor do Débito por Tributo para a Atividade."
        ];
    }

    $onInit() {}
}

angular
    .module("nucont.shared")
    .controller("AccountsRelationCtrl", [
        "$mdDialog",
        "DSNDialogService",
        "locals",
        AccountsRelationCtrl
    ]);
